import styled from 'styled-components';
const percentageSize = 1.3;

export const TableWrapper = styled.div`
  overflow-y: scroll;
  height: calc(${({ altura }) => altura}px - 105px);
  overflow-x: ${({ isMobile }) => (isMobile ? 'hidden' : null)};
  margin: 0px 10px 0px 10px;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-top: 5px;
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 5px;
  /* overflow: hidden; */
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const TableRowTitle = styled.thead`
  position: sticky;
  top: 0;
`;

export const TableTitle = styled.th`
  border-bottom: 2px solid #ccc;
  min-width: 100px;
  white-space: nowrap;
  cursor: pointer;
  /* text-align: center; */
  height: 40px;
  background-color: rgba(51, 51, 51);
  padding: 2px 10px;
`;
export const TableGoToFilter = styled.th`
  border-bottom: 2px solid #ccc;
  white-space: nowrap;
  width: 30px;
  cursor: pointer;
  /* text-align: center; */
  height: 40px;
  background-color: rgba(51, 51, 51);
  padding: 2px 10px;
`;

export const TableGoToFeature = styled.th`
  border-bottom: 2px solid #ccc;
  white-space: nowrap;
  width: 100px;
  cursor: pointer;
  /* text-align: center; */
  height: 40px;
  background-color: rgba(51, 51, 51);
  padding: 2px 10px;
`;

export const TableContent = styled.td`
  /* min-width: 100px; */
  /* width: calc(100% / ${({ number }) => number}); */
  /* text-align: center; */
  cursor: pointer;
  padding: 5px 10px;
`;
export const TableSort = styled.button`
  color: white;
  background-color: transparent;
  border: none;
  font-weight: bold;
`;
export const TableRow = styled.tr`
  background-color: ${({ count }) => (count % 2 === 0 ? 'rgba(20,20,20,0.45)' : 'rgba(60,60,60,0.5)')};
  box-shadow: ${({ isHighLight }) => (isHighLight ? 'inset 0px 0px 5px 1px #febf00dd' : null)};
`;

export const TableNextPrevButton = styled.button`
  cursor: ${({ enabled }) => (enabled ? 'pointer !important' : 'default !important')};
  background-color: transparent;
  border: none;
`;

export const TablePaginationSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  fill: 'gray',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))`
  margin: 1px 6px;
`;

export const TablePaginationSvgPadding = styled.div`
  padding: 1px 6px;
`;

export const OvalContainer = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  display: flex;
  justify-content: center;
`;

export const TableExportButtons = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  margin-right: 5px;
`;

export const TableExportWrapper = styled.div`
  /* margin-left: 30px; */
`;

export const TableFooterWrapper = styled.div`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  display: flex;
  gap: ${({ isMobile }) => (isMobile ? '30px' : null)};
  margin: ${({ isMobile }) => (isMobile ? '0 18%' : '0px 10px')};
  padding-bottom: 2px;
  justify-content: ${({ isMobile }) => (isMobile ? 'flex-start' : 'flex-end')};
  align-items: center;
`;

export const TableFooterOpenFilter = styled.button`
  /* position: absolute;
  right: 0%; */
  background-color: #666666;
  border: none;
  border-radius: 5px;
`;
export const TableTabWrapper = styled.div`
  margin: 5px 10px 0px 10px;
  display: flex;
  height: 40px;
  white-space: nowrap;
`;
export const TableTabBar = styled.div`
  position: absolute;
  top: 68px;
  width: 98%;
  border-bottom: 2px solid white;
  @media screen and (max-width: 768px) {
    top: 93px;
  }
`;
export const TableTabElement = styled.button`
  background: transparent;
  display: flex;
  justify-content: space-between;
  border: none;
  border-bottom: ${({ selected }) => (selected ? '2px solid #febf00' : '2px solid white')};
  /* border-right: 1px solid #999999; */
  color: ${({ selected }) => (selected ? '#febf00' : 'white')};
  padding-right: 5px;
  padding-bottom: 8px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const TableTabCloseBtn = styled.button`
  padding: 0;
  margin-left: 15px;
  background: transparent;
  border: none;
`;

export const TableNoResults = styled.div`
  height: 100%;
  color: white;
  padding: 10px;
`;

export const TableNoResultsOpenFiltre = styled.span`
  color: #febf00;
  cursor: pointer;
  text-decoration: underline;
`;
export const TableMobileCard = styled.div`
  width: 95%;
  cursor: pointer;
  color: white;
  background-color: rgba(51, 51, 51);
  box-shadow: ${({ isHighLight }) => (isHighLight ? 'inset 0px 0px 5px 1px #febf00dd' : null)};

  margin: 10px;
  padding: 10px;
`;
export const TableMobilePair = styled.div`
  display: flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  padding: 5px;
`;
export const TableMobileKey = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  /* min-width: 100px; */
  margin-right: 5px;
  font-weight: bold;
`;

export const TableMobileValue = styled.div`
  overflow: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const TableMobileFooterInfo = styled.div`
  flex: 0 0 auto;
`;

export const TableMobilePaginationWrapper = styled.div`
  /* display: flex;
  justify-content: space-between; */
  flex: 1 0 auto;
`;

export const AccionsWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  /* justify-content: center; */
  align-items: center;
`;

export const TablePaginationWrapper = styled.div`
  /* flex: 1 0 auto; */
  margin-left: auto;
`;

export const AccionsTitle = styled.div`
  /* margin: auto; */
`;
export const TableObrirFiltreMobil = styled.div`
  color: #febf00;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
`;

export const TabSelectorWrapper = styled.div`
  position: relative;
  margin: 10px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
`;
export const TabSelector = styled.div`
  width: 88%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #cccccc;
`;

export const TabSelectedTitle = styled.div`
  color: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const TabOptionsContainer = styled.div`
  /* display: none; */
  position: absolute;
  width: 88%;
  top: 30px;
  left: 0px;
  max-height: 160px;
  background-color: #666666;
  border: 1px solid #333333;
  overflow-y: scroll;
`;

export const TabOptionWrapper = styled.div`
  display: flex;
  padding: 1px 5px;
  width: 100%;
  height: 35px;
  align-items: center;
  justify-content: space-between;
`;

export const TabOptionTitle = styled.div`
  color: white;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;
